






















































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import {
  getInfo, HealthRuleData, HRRuleData, postData
} from '@/api/healthRule/index'
import PageForm from '@/components/pageLayout/form.vue'
import { deepCopy } from '@/configs/functions'
import { percentFilter } from '@/configs/filters'

@Component({
  components: {
    PageForm
  }
})
export default class HealthRuleSetting extends Vue {
  public loading = false

  public ruleStatusList: any[] = [
    { Key: 2, Val: '开启' },
    { Key: 1, Val: '关闭' }
  ]
  public ruleList: any[] = []
  public colorList: any[] = []
  public colorScoreList: any[] = []
  public redCodeRuleList: any[] = []

  public form: HealthRuleData = new HealthRuleData()
  // dynamic component
  public $refs!: {
    formCtrl: PageForm
  }

  public created() {
    this.fetchSource()
  }
  public fetchSource() {
  }
  public mounted() {
    this.fetchData()
  }
  public fetchData() {
    this.loading = true
    getInfo().then((response: { data: any }) => {
      var data = response.data
      if (data) {
        this.setData(data)
      }
      this.loading = false
    })
  }
  public setData(f: HealthRuleData) {
    this.ruleList = []
    f.RuleList.forEach((e: HRRuleData, i: number) => {
      var d = deepCopy(e)
      var content = d.RuleContent

      d.hasContent = this.paramExsit(content, this.contentReplace)
      d.hasResult = this.paramExsit(content, this.resultReplace)
      d.hasScore = this.paramExsit(content, this.scoreReplace)
      d.colSpan = 24
      var paramCount = 0
      if (d.hasContent) {
        paramCount++
      }
      if (d.hasResult) {
        paramCount++
      }
      if (d.hasScore) {
        paramCount++
      }
      if (paramCount > 0) {
        d.colSpan = 24 / paramCount
      }
      d.paramCount = paramCount
      d.ApplyContent = this.getContent(e)
      this.ruleList.push(d)
    })

    this.colorList = f.ColorList
    this.colorScoreList = f.ColorScoreList
    this.redCodeRuleList = f.RedCodeRuleList
  }
  //#region 规则列表变量
  public contentReplace = '{{内容变量}}'
  public resultReplace = '{{结果变量}}'
  public scoreReplace = '{{分值变量}}'
  public paramExsit(content: string, param: string) {
    return content.indexOf(param) > -1
  }
  public getContent(e: any) {
    // var e = this.ruleList[index]
    let content = e.RuleContent
    let percent = e.RuleCode.indexOf('Rate') > -1

    if (this.paramExsit(content, this.contentReplace)) {
      // content = content.replace(this.contentReplace, e.RuleParam)
      content = this.htmlReplace(content, this.contentReplace, e.RuleParam)
    }
    if (this.paramExsit(content, this.resultReplace)) {
      let reult = e.ResultParam
      if (percent) {
        reult = percentFilter(reult)
      }
      // content = content.replace(this.resultReplace, reult)
      content = this.htmlReplace(content, this.resultReplace, reult)
    }
    if (this.paramExsit(content, this.scoreReplace)) {
      // content = content.replace(this.scoreReplace, e.RuleSorce)
      content = this.htmlReplace(content, this.scoreReplace, e.RuleSorce)
    }
    return content
  }
  public htmlReplace(str: string, oldStr: string, newStr: string) {
    var rep = `<span class='color-danger'>{${newStr}}</span>`
    return str.replace(oldStr, rep)
  }
  public paramApply(i: number) {
    var item = this.ruleList[i]
    item.ApplyContent = this.getContent(item)
  }
  //#endregion

  public onSubmit() {
    var formData = {
      RuleList: this.ruleList,
      ColorList: this.colorList,
      ColorScoreList: this.colorScoreList,
      RedCodeRuleList: this.redCodeRuleList
    }
    postData(formData).then((response: { data: any }) => {
      const data = response.data
      if (data && !data.IsError) {
        this.$message({
          message: `保存成功`,
          type: 'success'
        })
        // this.fetchData()
        // this.$router.push({ path: '/ScoreColors' })
      } else {
        this.$message({
          dangerouslyUseHTMLString: true, message: `${data.Message}`,
          type: 'success'
        })
        console.log('保存失败', data)
      }
    }, (data: any) => {
      console.log(data);
    })
  }
  @Watch('$route')
  public onRouteChange(route: any) {
    this.fetchData()
  }
}
